const convertToSentenceCase = (str: string): string => {
  if (!str || str.length === 0) {
    return '';
  }
  return str
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

const capitalizeFirstLetter = (str: string) => {
  if (!str) return ""; // Handle empty or null strings
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

const capitalizeOnlyFirstLetter = (str: string) => {
  if (!str) return ""; // Handle empty or null strings
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const splitByCapital = (str: string) => {
  return str.split(/(?=[A-Z])/).join(" ");
};

const fixMojibake = (str: string) => {
  return str
    .replace(/Ã¢â‚¬â„¢/g, "’")
    .replace(/‚ Aos/g, "’s")
    .replace(/‚Ä¢/g, "<br/>•")
    .replace(/‚ oe/g, "•")
    .replace(/‚Äì/g, "<br/>-")
    .replace(/‚Äî/g, " – ")
    .replace(/‚ Ai/g, "-")
    .replace(/‚Äôs/g, "’s");
}


const stringUtils = {
  convertToSentenceCase,
  capitalizeFirstLetter,
  capitalizeOnlyFirstLetter,
  splitByCapital,
  fixMojibake
};


export default stringUtils;
